/**
 * Utilitaire de translittération basique Arabe <-> Latin
 * Adapté pour les noms propres marocains courants.
 */

const arToLatMap: Record<string, string> = {
  'ا': 'a', 'أ': 'a', 'إ': 'e', 'آ': 'a',
  'ب': 'b', 'ت': 't', 'ث': 'th', 'ج': 'j', 'ح': 'h', 'خ': 'kh',
  'د': 'd', 'ذ': 'z', 'ر': 'r', 'ز': 'z', 'س': 's', 'ش': 'ch',
  'ص': 's', 'ض': 'd', 'ط': 't', 'ظ': 'z', 'ع': 'a', 'غ': 'gh',
  'ف': 'f', 'ق': 'q', 'ك': 'k', 'ل': 'l', 'م': 'm', 'ن': 'n',
  'ه': 'h', 'و': 'ou', 'ي': 'i', 'ى': 'a', 'ة': 'a', 'ء': '', 'ئ': 'i', 'ؤ': 'ou'
};

const latToArMap: Record<string, string> = {
  'a': 'ا', 'b': 'ب', 'c': 'ك', 'd': 'د', 'e': 'ي', 'f': 'ف', 'g': 'غ',
  'h': 'ه', 'i': 'ي', 'j': 'ج', 'k': 'ك', 'l': 'ل', 'm': 'م', 'n': 'ن',
  'o': 'و', 'p': 'ب', 'q': 'ق', 'r': 'ر', 's': 'س', 't': 'ت', 'u': 'و',
  'v': 'ف', 'w': 'و', 'x': 'كس', 'y': 'ي', 'z': 'ز',
  'ch': 'ش', 'kh': 'خ', 'gh': 'غ', 'ou': 'و', 'th': 'ث'
};

export const hasArabicCharacters = (text: string): boolean => {
  return /[\u0600-\u06FF]/.test(text);
};

export const transliterateArToFr = (text: string): string => {
  if (!text) return '';
  let res = '';
  for (let char of text) {
    if (arToLatMap[char] !== undefined) res += arToLatMap[char];
    else if (char === ' ') res += ' ';
    // Ignorer les harakat
  }
  // Capitalize each word
  return res.split(' ').map(w => w.charAt(0).toUpperCase() + w.slice(1)).join(' ');
};

export const transliterateFrToAr = (text: string): string => {
  if (!text) return '';
  let res = text.toLowerCase();
  
  // Replace multi-char sounds first
  res = res.replace(/ch/g, 'ش').replace(/kh/g, 'خ').replace(/gh/g, 'غ').replace(/ou/g, 'و');
  
  // Replace single chars
  let finalAr = '';
  for (let char of res) {
    if (latToArMap[char] !== undefined) finalAr += latToArMap[char];
    else if (char === ' ') finalAr += ' ';
    else if (/[\u0600-\u06FF]/.test(char)) finalAr += char; // already Arabic
  }
  return finalAr;
};
